import { Component, Input, OnChanges } from "@angular/core";
import { IAccount } from "@app/services/account.service";
import { NavigationService } from "@services/navigation.service";
import { Observable } from "rxjs";
import { FoundationNavigationModule } from "../../foundation.navigation";
import { AccountService } from "../../_services/account.service";

import "./customer-name.component.scss";

@Component({
    selector: "customer-name",
    template: require("./customer-name.component.html")
})
export class CustomerNameComponent implements OnChanges {
    @Input() accountId: number;

    customer$: Observable<IAccount>;

    constructor(
        private readonly accountService: AccountService,
        private readonly navigationService: NavigationService) {

    }

    ngOnChanges() {
        if (!this.accountId) {
            return;
        }

        this.customer$ = this.accountService.getCustomerAccount(this.accountId);
    }

    customerClicked() {
        this.navigationService.go(FoundationNavigationModule.CustomerView, { customerId: this.accountId });
    }
}
